import _ from "lodash";
import React from "react";

import { FormFieldContainer } from "../../../../../component-library/FormFields/FormFieldContainer/FormFieldContainer";
import { FormTextInput } from "../../../../../component-library/FormFields/FormTextInput/FormTextInput";
import { Text } from "../../../../../component-library";

export const AdvancedCareActivityTextInput = ({
  formikProps,
  name,
  readOnly,
  testId,
  ...props
}) => {
  const value = _.get(formikProps.values, name);

  return (
    <>
      {!readOnly && (
        <FormTextInput formikProps={formikProps} name={name} {...props} testId={testId} />
      )}

      {readOnly && (
        <FormFieldContainer {...props}>
          <Text className="AdvancedCareActivityForm-text_area_read_only" testId={testId}>
            {value}
          </Text>
        </FormFieldContainer>
      )}
    </>
  );
};
